import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {i18n, loadLanguageAsync} from './i18n'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

export const eventBus = new Vue();

loadLanguageAsync().then(() => new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app'))


